import React from 'react';

const NotFound = () => {
  return (
    <>
      <h1>Sorry page does not exist!</h1>
    </>
  );
};

export default NotFound;
